
import { Component, Vue, Watch } from 'vue-property-decorator'
import PackageSelector from '@/views/industryMall/components/PackageSelector/index.vue'
import PackageSelector1 from '@/views/industryMall/components/PackageSelector/indexCopy.vue'
import { Getter, Action } from 'vuex-class'
import { getStoreLevelManageList, getPackagePriceList, modifyGoodsPriceSubmit } from '@/api/goodsModule'
import { keepDecimal } from '@/utils/util'

@Component({
  name: 'DifferentialPricing',
  components: {
    PackageSelector,
    PackageSelector1
  }
})
export default class differentialPricing extends Vue {
  @Getter companyId!: string
  options = [
    { text: '折扣比例', value: 1 },
    { text: '折扣金额', value: 2 }
  ]
  method = 1
  levelList: Array<any> = []
  specsValue = 0
  keepDecimal = keepDecimal

  created () {
    this.specsValue = Number(this.$route.query.marketPrice as string)
    Promise.all([this.getStoreLevelManageList(),this.getPackagePriceList()]).then((res: any) => {
      this.levelList = res[0].map(item => {
        item.finalPriceCopy = this.specsValue * item.buyDiscount
        item.finalPrice = this.specsValue * item.buyDiscount
        item.buyDiscount = (item.buyDiscount * 100).toFixed()
        item.buyDiscountCopy = item.buyDiscount
        item.buySubtract = ''
        item.discountType = 1
        item.buySubtractCopy = item.buySubtract
        return { ...item }
      })
      res[1].map((item:any) => {
        let obj = this.levelList.find(ii => ii.levelId === item.levelId)
        if (item.buyDiscount) {
          obj.finalPriceCopy = this.specsValue * item.buyDiscount
          obj.finalPrice = this.specsValue * item.buyDiscount
          obj.buyDiscount = (item.buyDiscount * 100).toFixed()
          obj.buySubtract = ''
          this.$set(obj, 'discountType', 1) // 折扣比例
        }
        if (item.buySubtract) {
          obj.finalPriceCopy = ((this.specsValue * 1000) - (item.buySubtract * 1000)) / 1000
          obj.finalPrice = ((this.specsValue * 1000) - (item.buySubtract * 1000)) / 1000
          obj.buySubtract = item.buySubtract
          obj.buyDiscount = ''
          this.$set(obj, 'discountType', 2) // 折扣金额
        }
        obj.buyDiscountCopy = obj.buyDiscount
        obj.buySubtractCopy = obj.buySubtract
      })
    })
    // this.getStoreLevelManageList().then()
    // this.getPackagePriceList()
  }

  getStoreLevelManageList () {
    const params = {
      storeId: this.companyId,
      isPage: 1,
      pageIndex: 1,
      pageSize: 1000
    }
    return new Promise((resolve, reject) => {
      getStoreLevelManageList(params).then(res => {
        resolve(res.data.records)
      })
    })
  }

  getPackagePriceList () {
    const params = {
      storeId: this.companyId,
      goodsId: this.$route.query.goodsId,
      packageId: this.$route.query.packageId
    }
    return new Promise((resolve, reject) => {
      getPackagePriceList(params).then(res => {
        resolve(res.data)
      })
    })
    // getPackagePriceList(params).then(res => {
    //   // res.data.map((item:any) => {
    //   //   let obj = this.levelList.find(ii => ii.levelId === item.levelId)
    //   //   if (item.buyDiscount) {
    //   //     obj.finalPriceCopy = this.ruleForm.specsValue * item.buyDiscount
    //   //     obj.finalPrice = this.ruleForm.specsValue * item.buyDiscount
    //   //     obj.buyDiscount = (item.buyDiscount * 100).toFixed()
    //   //     obj.buySubtract = ''
    //   //     this.$set(obj, 'discountType', 1) // 折扣比例
    //   //   }
    //   //   if (item.buySubtract) {
    //   //     obj.finalPriceCopy = ((this.ruleForm.specsValue * 1000) - (item.buySubtract * 1000)) / 1000
    //   //     obj.finalPrice = ((this.ruleForm.specsValue * 1000) - (item.buySubtract * 1000)) / 1000
    //   //     obj.buySubtract = item.buySubtract
    //   //     obj.buyDiscount = ''
    //   //     this.$set(obj, 'discountType', 2) // 折扣金额
    //   //   }
    //   //   obj.buyDiscountCopy = obj.buyDiscount
    //   //   obj.buySubtractCopy = obj.buySubtract
    //   // })
    // })
  }

  changeVal () {
    // @ts-ignore
    this.specsValue = this.specsValue.replace(/[^\d.]/g, '')
    this.levelList = this.levelList.map(item => {
      if (item.buyDiscountCopy) {
        item.finalPriceCopy = this.specsValue * item.buyDiscountCopy / 100 + ''
        const num = Number(item.finalPriceCopy)
        item.finalPriceCopy = Math.round(num * 100) / 100 + ''
      }
      if (item.buySubtractCopy) {
        item.finalPriceCopy = ((this.specsValue * 1000) - (item.buySubtractCopy * 1000)) / 1000 + ''
      }
      item.finalPrice = this.specsValue * item.buyDiscount
      return { ...item }
    })
  }

  handleVal () {
    // @ts-ignore
    this.specsValue = keepDecimal(this.specsValue, 2)
  }

  /**
   * @description 输入框失焦
   */
  inputBlur (type: string, record: any, val: any) {
    // let index = this.packageIdList.findIndex((item) => item.packageId === record.packageId)
    console.log('record=====', record)
    // 折扣比例不能为0或者小于0判断
    if (type === 'subtractEdit') {
      record.buySubtractCopy = keepDecimal(record.buySubtractCopy, 2)
      if (Number(record.buySubtractCopy) === 0) {
        record.buySubtractCopy = record.blurSubtractData
        this.$set(record, type, false)
        return false
      }
    }
    if (type === 'discountEdit') {
      if (Number(record.buyDiscountCopy) > 100) {
        record.buyDiscountCopy = 100
      } else if (Number(record.buyDiscountCopy) <= 0) {
        record.buyDiscountCopy = 1
      } else {
        record.buyDiscountCopy = keepDecimal(record.buyDiscountCopy, 2)
      }
    }
    // 处理最终价问题
    this.handleInputData(type, record)
    // 输入类型
    if (type === 'discountEdit') {
      if (record.buyDiscountCopy) {
        record.buySubtractCopy = ''
      } else {
        record.buySubtractCopy = record.buySubtract
      }
    }
    if (type === 'subtractEdit') {
      let price = ((this.specsValue * 1000) - (record.buySubtractCopy * 1000)) / 1000
      if (price <= 0) {
        this.$toast('最终定价不能小于等于0')
        return false
      }
      if (record.buySubtractCopy) {
        record.buyDiscountCopy = ''
      } else {
        record.buyDiscountCopy = record.buyDiscount
      }
    }
    // 不能同时为空
    if (!record.buyDiscountCopy && !record.buySubtractCopy) {
      this.$toast('不能同时为空')
      return false
    }
    // 实时输入的折扣值
    if (record.buySubtractCopy) {
      record.blurSubtractData = record.buySubtractCopy
    } else {
      record.blurSubtractData = record.buySubtract
    }

    this.$set(record, type, false)
  }

  handleInputData (type:string, record:any) {
    if (type === 'discountEdit' && record.buyDiscountCopy) {
      record.finalPriceCopy = this.specsValue * record.buyDiscountCopy / 100 + ''
      // 处理 21.255 四舍五入后 是 21.25问题
      const num = Number(record.finalPriceCopy)
      record.finalPriceCopy = Math.round(num * 100) / 100 + ''
    }
    if (type === 'subtractEdit') {
      if (record.buySubtractCopy) {
        record.finalPriceCopy = ((this.specsValue * 1000) - (record.buySubtractCopy * 1000)) / 1000 + ''
      } else {
        record.finalPriceCopy = this.specsValue * record.buyDiscount + ''
        // ((this.ruleForm.specsValue * 1000) - (item.buySubtract * 1000)) / 1000
      }
    }
  }

  changeText (type:string, record:any, val:any) {
    record.buySubtractCopy = record.buySubtractCopy.replace(/[^\d.]/g, '')
    let reg = /^[1-9]\d*$/
    // record.buySubtractCopy = record.buySubtractCopy.replace(/[^0-9.]/g, '')
    if (!reg.test(val) && type === 'discountEdit') return false
  }

  confirm () {
    let flag = true
    let levelPriceList = this.levelList.map(item => {
      if (Number(this.specsValue) === Number(item.buySubtractCopy)) {
        flag = false
      }
      if (item.finalPriceCopy <= 0) {
        flag = false
      }
      // if (item.buyDiscountCopy) {
      //   item.buyDiscountCopy = item.buyDiscountCopy
      // }

      return {
        levelId: item.levelId,
        packageId: this.$route.query.packageId,
        buyDiscount: item.buyDiscountCopy && item.buyDiscountCopy / 100,
        buySubtract: item.buySubtractCopy
      }
    })
    if (!flag) {
      this.$toast('设置失败，存在优惠后小于等于0元的商品套餐')
      return false
    }
    modifyGoodsPriceSubmit({
      packageId: this.$route.query.packageId,
      marketPrice: this.specsValue,
      levelPriceList
    }).then(res => {
      window.localStorage.setItem('modifyPriceIndex', this.$route.query.index as string)
      this.$toast.success('修改成功')
      this.$router.back()
    })
  }
}
